// Reader-Cover (2026-06-01) — echten Pro-Scrolly-Thumbnail-URL aus dem
// geladenen Scrolly-JSON lesen, für den Reader-START-Hero (CoverSection).
//
// ⚠️  EXAKTE SPIEGELUNG von Cover-Fix A:
//       portal/src/lib/api/home-scrollys.ts → extractThumbnailUrl()
//     Feed (portal) und Reader (public) MÜSSEN dieselbe 5-Pfad-Priorität
//     nutzen — sonst zeigen sie irgendwann VERSCHIEDENE Cover. Wer hier
//     etwas ändert, ändert BEIDE Stellen (kein Drift).
//
// Warum gespiegelt statt geteilt: `portal` konsumiert `@scrolly/post-types`
// NICHT (nur `@scrolly/branding` + `@scrolly/tokens`), und A's Funktion lebt
// in `portal`. Es gibt heute kein Shared-Package, das BEIDE konsumieren —
// echtes Teilen bräuchte einen post-types-Dep + Refactor/Redeploy des Feeds
// (außerhalb dieser Fläche). Single-Source-Konsolidierung kommt mit C
// (OG-Render), das Feed + Reader gemeinsam ablöst. Bis dahin: exakte
// Spiegelung. Gemeinsame Herkunft: app/src/utils/scrolly-display.ts
// (`getScrollyThumbnail`).

/**
 * Liest den ersten nicht-leeren Thumbnail-URL aus dem Scrolly-JSON.
 *
 * Reihenfolge (erste gewinnt):
 *   1. json.meta.thumbnail                     (neues Sections-Format)
 *   2. json.metadata.thumbnailResized.url      (PostBackend-Level, = PPI-Import)
 *   3. json.metadata.thumbnail
 *   4. json.data.metadata.thumbnailResized.url (PostJson-Level, Legacy-Nesting)
 *   5. json.data.metadata.thumbnail
 *
 * Liefert `undefined`, wenn kein Thumbnail gesetzt ist → der Caller fällt
 * dann auf den konstanten dunklen Cover-Hintergrund zurück.
 */
export function extractThumbnailUrl(json: unknown): string | undefined {
  if (!json || typeof json !== "object") return undefined;
  // Scrolly-`json` ist `unknown`-getypt unterhalb der bekannten Felder;
  // wir navigieren defensiv über `any` (gleich wie die portal/app-Vorlage).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const j = json as any;
  const candidate: unknown =
    j?.meta?.thumbnail ||
    j?.metadata?.thumbnailResized?.url ||
    j?.metadata?.thumbnail ||
    j?.data?.metadata?.thumbnailResized?.url ||
    j?.data?.metadata?.thumbnail ||
    undefined;
  return typeof candidate === "string" && candidate.trim().length > 0
    ? candidate.trim()
    : undefined;
}
